<template>
  <div class="fts-dropdown">
    <!-- <div style="background: pink;">
      <div>def: {{formData[item.fieldName]}}</div>
      <div>id: {{formData[item.fieldName + 'Id']}}</div>
      <div>label: {{label}}</div>
      <div>Allow Other: {{item.allowOther}}</div>
      <div>key: {{item.key}}</div>
      <div>connectionId: {{item.connectionId}}</div>
      <div>id: {{item.id}}</div>
    </div> -->
    <!-- To Enable new select func need to replace:
    :searchable="true"
    :create-option="option => ({ id: option, name: option, color: null })"
    :select-allow-customize = "true" 
    -->
    <v-select
      :append-to-body="appendToBody"
      :label="label"
      :options="list"
      :searchable="!selectOption || !taggable || item.type == 24"
      :filterable="true"
      :is-context="item.type == 24"
      :allow-other="false"
      :multiple="multiple"
      :can-add-new="item.canAddNew"
      :connection-id="item.connectionId" 
      :search-field="item.searchField" 
      :text="formData[item.fieldName]"
      :key-property="keyProperty"
      max-height="200px"
      :placeholder="'Please select one'"
      :create-option="option => ({ id: option, name: option, color: null })"
      :select-customize-display-name="item.displayName"
      :select-customize="selectOption && item.type != 24"
      :select-allow-customize="allowCustomize"
      :with-color="selectOption && item.type != 24 && !item.reference"
      :taggable="selectOption && taggable"
      :comfort-design="comfortDesign"
      @input="$emit('input')"
      @addedNew="addedNew"
      @newOption="optionCreated"
      @search="onSearch"
      @search:blur="$emit('blur')"
      @keyUpdate="updateKey"
      @textUpdate="updateText"
      ref="scroll">
      <template v-slot:option="option">
        <slot name="option" v-bind="option">
          <template v-if="!selectOption">
            <template v-if="option && option.optionName">{{option.optionName}}</template>
            <template v-else-if="option && item.displayProperty">{{option[item.displayProperty]}}</template>
            <template v-else-if="option && option.name">{{option.name}}</template>
            <div class="undefined-option" v-else>(undefined)</div>
          </template>
        </slot>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from "../vue-select/index";
import mixin from "../mixins/mixin";

import { classificationStore } from "../store/classificationStore";
import commons from "../commons/commons";

export default {
  props: {
    item: Object,
    formData: Object,
    appendToBody: {
      type: Boolean,
      default: true
    },
    multiple: Boolean,
    taggable: Boolean,
    allowCustomize: Boolean,   
    comfortDesign: Boolean,
    moduleDesign: [String, Number],
    locusDetail: Boolean,
    locusId: {
      type: Number,
      default: null
    },
  },
  components: {
    "v-select": vSelect
  },
  mixins: [mixin],
  data() {
    return {
      list: []
    };
  },
  computed: {
    keyProperty() {
      if (this.item.keyProperty != null) return this.item.keyProperty;
      else if (this.item.searchProperty != null)
        return this.item.searchProperty;
      else if (this.item.reference) {
        return "entityId";
      } else return "id";
    },
    label() {
      if (this.item.type == 24) {
        return "optionName";
      } else if (this.item.reference) {
        return "optionName";
      } else if (this.selectOption) {
        // Select currently can't set displayProperty
        if (this.item.displayProperty) 
          return this.item.displayProperty;
        else
          return "name";
      } else if (this.item.connectionId) {
        // CodeCheck
        // if (this.item.displayTemplate) return "optionName";
        // else
        // EndCodeCheck
        // New design doesn't have "displayProperty" setting
        // if (this.item.displayProperty)
        //   return this.item.displayProperty;
        // New
        // else if (this.item.connectionFieldName == "$DocumentId")
        //   return "documentId";
        // else if (this.item.connectionFieldName)
        //   return `extension.${this.item.connectionFieldName}`;
        if (this.item.searchField == "DocumentId") 
          return "documentId";
        else if (this.item.searchField)
          return `extension.${commons.camelize(this.item.searchField)}`;
        else 
          return "value";
      }  
      
      if (this.item.displayProperty)
        return this.item.displayProperty;
      else
        return "name";
    },
    selectOption() {
      return this.item.type == 27 || this.item.input == 'select' || this.item.type == 24;
    },
  },
  methods: {
    getContextOption(option) {
      return { id: option.id, name: option.optionName };
    },
    optionCreated(option) {
      this.item.optionList.push(option);
    },
    updateKey(item) {
      if (item) {
        if (this.item.key) 
          this.$set(this.formData, this.item.key, item);
        if (this.item.key == null)
          this.$set(this.formData, `${this.item.fieldName}Id`, item);
      } else {
        if (this.formData[this.item.key])
          this.$delete(this.formData, this.item.key);
        if (this.formData[`${this.item.fieldName}Id`])
          this.$delete(this.formData, `${this.item.fieldName}Id`);
        if (this.formData[this.item.fieldName] && !this.item.allowOther)
          this.$delete(this.formData, this.item.fieldName)
      }
    },
    updateText(item) {
      if (item) 
        this.$set(this.formData, this.item.fieldName, item);
      else if (this.formData[this.item.fieldName])
        this.$delete(this.formData, this.item.fieldName);
    },
    onSearch(search, loading, pageNumber, loadingMore) {
      // if (this.item.optionList != null && (this.item.type == this.item.input == 'select' || this.item.connectionId == null || this.item.connectionId == 0) && !this.item.reference) {
      //   loading = false;
      //   this.list = this.item.optionList;
      // }
      if (
        (this.selectOption ||
          this.item.connectionId == null ||
          this.item.connectionId == 0) &&
        !this.item.reference && this.item.type != 24
      ) {
        loading = false;
        this.list = this.item.optionList;
      } else if (this.item.reference) {
        if (pageNumber == 0) {
          loading(true);
          this.search(loading, search, this, pageNumber, loadingMore);
        }
      } else {
        console.log("querying...");
        if (pageNumber == 0) loading(true);
        else loadingMore(true);
        this.search(loading, search, this, pageNumber, loadingMore);
      }
    },
    search: _.debounce((loading, search, vm, pageNumber, loadingMore) => {
      var dataToPassIn = {},
        lineDataToPassIn = {};
      if (classificationStore) {
        var originalFormData = classificationStore.state.formData;
        if (vm.item.autoCompleteFormDataFields && originalFormData) {
          _.each(vm.item.autoCompleteFormDataFields.split(","), function(
            field
          ) {
            dataToPassIn[field] = originalFormData[field];
            lineDataToPassIn[field] = vm.formData[field];
          });
        }

        var referenceModuleId = null;

        if (vm.item.reference && vm.item.referenceModuleField) {
          loadingMore(false);
          //pass in referene
          referenceModuleId =
            originalFormData[vm.item.referenceModuleField + "Id"];

          if (!referenceModuleId) {
            referenceModuleId =
              vm.formData[vm.item.referenceModuleField + "Id"];
          }
        }
      }

      let queryPayload = {
        text: search,
        currentPage: pageNumber,
        pageSize: 10,
        fieldId: vm.item.id,
        activityId: classificationStore.state.activityId,
        vectorId: classificationStore.state.vectorId != null? classificationStore.state.vectorId : vm.item.connectionId,
        documentId: classificationStore.state.documentId,
        reference: referenceModuleId,
        locusId: vm.locusId,
        formData: dataToPassIn,
        data: lineDataToPassIn,
        moduleDesign: vm.moduleDesign,
        locusDetail: vm.locusDetail,
      };

      classificationStore.dispatch("searchEntry", queryPayload).then(
        res => {
          loading(false);
          loadingMore(false);
          if (pageNumber == 0) {
            if (vm.$refs.scroll && vm.$refs.scroll.numberOfPageLoaded) {
              vm.$refs.scroll.numberOfPageLoaded = 0;
            }
            vm.list = res.data;
          } else {
            vm.list = vm.list.concat(res.data);
          }
        },
        error => {
          loading(false);
          loadingMore(false);
          console.error(error);
          console.warn(
            "Got nothing from server. Prompt user to check internet connection and try again"
          );
        }
      );
    }, 350),
    async addedNew(data) {
      let vm = this;
      let queryPayload = {
        pageSize: 10,
        id: data.id,
        vectorId: classificationStore.state.vectorId,
        activityId: classificationStore.state.activityId,
        fieldId: vm.item.id,
        documentId: classificationStore.state.documentId,
      };
      let result = await classificationStore.dispatch("searchEntry", queryPayload);

      if(result.data.length == 1) {
        let option = result.data[0];
        this.formData[this.item.fieldName + "Id"] = option.id;
        this.formData[this.item.fieldName] = this.getAttr(option, this.label);
        if(!this.formData[this.item.fieldName]) {
          this.formData[this.item.fieldName] = this.getAttr(option, 'optionName');
        }

        this.$forceUpdate();
      }
    },
  },
  watch: {
    "item.optionList": function() {
      let vm = this;
      vm.list = vm.item.optionList;

      if (vm.item.key && vm.formData[vm.item.key] != null) {
        let optionMatched = this.list.find(
          x => x[vm.keyProperty] == vm.formData[vm.item.key]
        );

        if (optionMatched)
          vm.formData[this.item.fieldName] = optionMatched[this.label];
      }
    }
  },
  mounted() {
    if (this.item.optionList) {
      let vm = this;
      vm.list = vm.item.optionList;

      if (vm.item.key && vm.formData[vm.item.key] != null) {
        let optionMatched = this.list.find(
          x => x[vm.keyProperty] == vm.formData[vm.item.key]
        );

        if (optionMatched)
          vm.formData[this.item.fieldName] = optionMatched[this.label];
      }
    }

    // if(this.item.type == 24) {
    //   this.formData[this.item.fieldName + 'Model'] = this.formData[this.item.fieldName];
    // }
  }
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.undefined-option {
  color: var(--fts-gray-5);
}
</style>
